module.exports = __webpack_public_path__ + "static/1-8d8965e1d89bdccdb6b73fa22b1a9b53.png";